import React from "react";
import { Dropdown, SelectProps } from "semantic-ui-react";
import { useAuthContext } from "../auth/AuthenticationProvider";
import { useApplicationConfiguration } from "../configuration/ConfigurationContext";
import { parseQuery, stringifyQuery } from "../utils/query.helper";



interface LanguageSelectProps { }

const LanguageSelect: React.FC<LanguageSelectProps> = () => {
    const { showLanguageSelect, languages } = useApplicationConfiguration()
    const { lang, changeLanguage } = useAuthContext();

    const selectChange: SelectProps["onChange"] = (_1, { value }) => {
        const { lang: queryLang, ...otherParams } = parseQuery<{ lang?: string }>(window.location.search);
        const nextLang = String(value);

        if (queryLang) {
            const nextHref = window.location.href.split("?")[0] + `?${stringifyQuery({ ...otherParams, lang: nextLang })}`
            window.location.href = (nextHref);
        }

        changeLanguage(nextLang)
    };

    const languageOptions = Object.values(languages).map((lang) => ({
        text: lang === "us" ? "English" : lang === "fi" ? "Suomi" : lang,
        value: lang
    }));

    const value = lang;

    if (!showLanguageSelect) {
        return null
    };

    return (
        <div className="LanguageSelect">
            <Dropdown
                value={value}
                options={languageOptions}
                onChange={selectChange}
                direction="left"
                basic
            />
        </div>
    );
};


export default LanguageSelect;
